<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    top="15vh"
    :modal-append-to-body="false"
    :before-close="handleClose"
    custom-class="custom-scrollable"
  >
    <div class="font-normal mb-4 mx-4">
      <div class="-mt-10">
        <div>
          <div class="flex justify-center items-center">
            <p class="text-2xl font-bold">Download Statement</p>
          </div>
          <div>
            <el-form
              v-model="downloadOptions"
              size="normal"
              label-position="top"
              label-width="80px"
            >
              <el-form-item label="Type" class="w-full mt-2">
                <el-select
                  class="w-full"
                  v-model="downloadOptions.type"
                  placeholder="Select"
                >
                </el-select>
              </el-form-item>
              <div class="flex items-center justify-center">
                <el-form-item label="Select start date" class="mr-2">
                  <el-date-picker
                    v-model="downloadOptions.startDate"
                    type="date"
                    placeholder="Pick a date"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="Select end date">
                  <el-date-picker
                    v-model="downloadOptions.endDate"
                    type="date"
                    placeholder="Pick a date"
                  >
                  </el-date-picker>
                </el-form-item>
              </div>
              <el-form-item label="Download Format">
                <el-select
                  class="w-full"
                  v-model="downloadOptions.format"
                  placeholder="CSV"
                >
                  <el-option
                    v-for="(option, index) in downloadOption"
                    :key="index"
                    :label="option.label"
                    :value="option.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <div
                class="w-full cursor-pointer rounded-3xl bg-primary text-white p-3 flex items-center justify-center"
              >
                Download
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
export default {
  name: 'DownloadDialog',
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data () {
    return {
      breakpoints,
      downloadOption: [
        {
          label: 'CSV',
          value: 1
        },
        {
          label: 'PDF',
          value: 2
        }
      ],
      downloadOptions: {
        type: '',
        startDate: '',
        endDate: '',
        format: ''
      }
    }
  },
  methods: {
    handleClose () {
      this.$emit('closeDialog')
    }
  },
  computed: {
    modalWidth () {
      return breakpoints.lgAndUp ? '37%' : breakpoints.mdAndUp ? '70%' : '90%'
    }
  }
}
</script>

<style scoped>
.grey-bg {
  background: #e0e0e0;
}
>>> .el-input__inner {
  border-radius: 6px;
  height: 55px;
}
>>> .el-date-table td.today span {
  color: var(--color-primary);
}
>>> .el-date-picker__header-label:hover {
  color: var(--color-primary);
}
>>> .el-date-table td span:hover {
  color: var(--color-primary);
}
>>> .el-date-table__row {
  color: var(--color-primary);
}
</style>
